
import React, { useEffect, useState, useContext } from 'react'
import { ContentContext } from '../../Contexts/Contents/Context.js';
/* COMPONENTES */
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';

/* importação da branch crud */
import BranchUseServiceSearch from './useServiceSearch';
import BranchUseServiceDelete from './useServiceDelete';

/* UTILITÁRIOS */
//import Permission from '../../utils/Permission.js'

import { usePaginator } from '../../utils/Paginator.js'

function useCase() {
    const { listData, setListData, getBroadcast, action, setAction, isLoading, setIsLoading, setBroadcast } = useContext(ContentContext)
    const { first, rows, onPageChange, template1 } = usePaginator();

    const [onResume, setOnResume] = useState({});
    const [getResult, setResult] = useState([]);
    const [error, setError] = useState(null);

    const data = {
        leftJoin: true,
        where: [],
        orderBy: "A.branch_id DESC",
        countAllRows: true,
        page: 1,
        limit: 10
    }

    const refresh = (page, r) => {
        console.log('%c~ * ~ USECASE::refresh ~ * ~', 'color: white; background-color: blue; padding: 4px;font-size: 12px', page, r);
        reloadList({ page: page, limit: r });
    }

    const handlerDelete = async (data) => {
        //console.clear();
        //console.log('%c~ * ~ URL ENVIADA A API - useCase :: DELETE ~ * ~', 'color: white; background-color: blue; padding: 4px;font-size: 18px');
        //console.log("- ", data);

        try {
            setIsLoading(true);
            const response = await new BranchUseServiceDelete().delete(data)
            const result = response.data.result;

            if (response.status == 200) {
                if (!!result.success.length) {
                    const newgetList = listData.filter(element => !result.success.includes(element.branch_id));                    
                    setListData(newgetList);
                    setIsLoading(false);
                    setOnResume({ summary: "Concluído!", detail: "Exclusão bem sucedida.", severity: "success" });
                }

                if (!!result.fail.length) {
                    setOnResume({ summary: "Falha!", detail: "Há exclusões não efetivadas.", severity: "error" });
                    setBroadcast({
                        "page": "branch",
                        "action": "post",
                        "segment": "list",
                        "command": "resetButtonDeleteGroup"
                    })
                }
            }

        } catch (error) {
            setOnResume({ summary: "Falha!", detail: "Não foi possível concluir a requisição", severity: "error" });
        }
        setIsLoading(false);
    }

    const reloadList = (newData) => {
        console.log('%c~ * ~ USECASE::reloadList ~ * ~', 'color: white; background-color: green; padding: 4px;font-size: 18px', newData);


        let sql = data;
        if (newData != null)
            sql = { ...data, ...newData };
        setIsLoading(true);
        const fetchData = async () => {
            try {                
                setIsLoading(true);
                const branchUseServiceSearch = new BranchUseServiceSearch();
                let getResult2 = await branchUseServiceSearch.execute(sql)
                console.log(":::: RESULTADO DA BUSCA :::: ", getResult2.data);

                setListData(getResult2.data.result);
                setBroadcast({
                    "page": "branch",
                    "action": "search",
                    "segment": "list",
                    "body": {
                        "command": "none"
                    },
                    "data": getResult2.data
                })                
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };

        fetchData();
    }

    useEffect(() => {        
        if (getBroadcast) {
            if (getBroadcast.command == "pagination") {
                console.log('%c~ * ~ USE EFFECT - getBroadcast::[] ~ * ~', 'color: #fff; background-color: blue; padding: 10px;', getBroadcast);
                refresh(getBroadcast.data.page, getBroadcast.data.rows)
            }
        }
    }, [getBroadcast])

    useEffect(() => {
        console.log('%c~ * ~ USE EFFECT - useCase::[] ~ * ~', 'color: #fff; background-color: #e34c26; padding: 10px;');
    }, []);

    function verificaPropriedades(a, b) {
        return b.map(b_item => {
            const matchingIndex = a.findIndex(el => el.branch_id === b_item.branch_id);
            if (matchingIndex !== -1) {
                return { ...b_item, ...a[matchingIndex] };
            }
            return b_item;
        });
    }
    useEffect(() => {        
        if (listData != null && action == "post") {
            setResult((current) => [...current, listData]);
        }

        if (listData != null && action == "patch") {
            const newResult = verificaPropriedades(listData, getResult);
            setAction("post")
            setResult(newResult);
        }

        if (listData != null && action == "search") {            
            setResult(listData);
        }
        setIsLoading(false);
    }, [listData]);

    useEffect(() => {
        let msg = "";
        if (error != null) {
            const data = error;
            if (data.status == 403) {
                msg = { summary: "Atenção!", detail: "data.resume.fail[0]", severity: "error" };
            } else {
                msg = { summary: "Falha!", detail: "Error", severity: "error" };
            }
            setOnResume(msg);
        }

    }, [error]);

    return { getResult, isLoading, onResume, first, rows, template1, handlerDelete, reloadList, onPageChange };
}

export default useCase;
        